module.exports = __webpack_public_path__ + "img/brush.59e45a7a.svg";